// extracted by mini-css-extract-plugin
module.exports = {"footer":"DEFooter_footer__AqnJp","item":"DEFooter_item__5zVUG"};